window.hmShopScriptLoaded = true;

if(typeof(ajax_url) != "undefined" && ajax_url !== null) {
    var shopurl = ajax_url;
}else{
    var shopurl = window.location.origin;
}

function runHmReadyQueue() {
    var queue = window.hmReadyQueue || [];
    window.hmReadyQueue = [];
    for (var i = 0; i < queue.length; i++) {
        if (typeof queue[i] === "function") {
            queue[i](jQuery);
        }
    }
}

if (typeof jQuery !== "undefined") {
    window.hmReady = function(callback) {
        jQuery(function() {
            callback(jQuery);
        });
    };
    jQuery(runHmReadyQueue);
}

function hmLoadScript(src, callback) {
    if (!src) {
        return;
    }

    window.hmScriptPromises = window.hmScriptPromises || {};

    if (!window.hmScriptPromises[src]) {
        window.hmScriptPromises[src] = new Promise(function(resolve, reject) {
            var script = document.createElement('script');
            script.src = src;
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    window.hmScriptPromises[src].then(function() {
        if (typeof callback === "function") {
            callback();
        }
    });
}

window.hmLoadScript = hmLoadScript;

function hmLoadBootstrap(callback) {
    if (window.bootstrap) {
        if (typeof callback === 'function') {
            callback();
        }
        return;
    }

    if (window.hmLoadBootstrap) {
        window.hmLoadBootstrap(callback);
        return;
    }

    hmLoadScript(window.hmAssets && window.hmAssets.bootstrap, callback);
}

function hmShowModal(target) {
    hmLoadBootstrap(function() {
        var element = typeof target === 'string' ? document.querySelector(target) : target;
        if (element && window.bootstrap && window.bootstrap.Modal) {
            window.bootstrap.Modal.getOrCreateInstance(element).show();
        }
    });
}

function hmHideModal(target) {
    hmLoadBootstrap(function() {
        var element = typeof target === 'string' ? document.querySelector(target) : target;
        if (element && window.bootstrap && window.bootstrap.Modal) {
            window.bootstrap.Modal.getOrCreateInstance(element).hide();
        }
    });
}

function hmShowAlert(options) {
    if (window.swal) {
        window.swal(options);
        return;
    }

    if (window.hmLoadSweetAlert) {
        window.hmLoadSweetAlert(function() {
            if (window.swal) {
                window.swal(options);
            }
        });
        return;
    }

    hmLoadScript(window.hmAssets && window.hmAssets.sweetAlert, function() {
        if (window.swal) {
            window.swal(options);
        }
    });
}

function hmClampQuantityInput(input, allowEmpty) {
    if (!input) {
        return null;
    }
    if (input.readOnly || input.disabled) {
        return Number(input.value);
    }
    if (allowEmpty && String(input.value).trim() === '') {
        return null;
    }

    var minimumAttribute = input.getAttribute('min');
    var minimum = minimumAttribute === null || minimumAttribute === '' ? 1 : Number(minimumAttribute);
    var maximumAttribute = input.getAttribute('max');
    var maximum = maximumAttribute === null || maximumAttribute === '' ? null : Number(maximumAttribute);
    var value = String(input.value).trim() === '' ? minimum : Number(input.value);
    if (!Number.isFinite(minimum)) minimum = 1;
    if (maximum !== null && !Number.isFinite(maximum)) maximum = null;
    if (!Number.isFinite(value)) value = minimum;
    value = Math.max(minimum, value);
    if (maximum !== null) value = Math.min(maximum, value);
    input.value = value;

    var field = input.closest('.qtyField');
    if (field) {
        field.querySelectorAll('.qtyBtn').forEach(function(button) {
            var disabled = button.classList.contains('plus')
                ? maximum !== null && value >= maximum
                : value <= minimum;
            button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
            button.classList.toggle('disabled', disabled);
        });
    }

    return value;
}

function hmSetProductQuantityLimit(maximum) {
    document.querySelectorAll('.product-form').forEach(function(form) {
        if (maximum === null || maximum === undefined || maximum === '') {
            form.removeAttribute('data-max-quantity');
        } else {
            form.setAttribute('data-max-quantity', Math.max(0, Math.floor(Number(maximum))));
        }
        calculateCarton(jQuery(form));
    });
}

document.addEventListener('input', function(event) {
    if (event.target.matches('.qtyField input.qty')) {
        hmClampQuantityInput(event.target, true);
    }
}, true);

document.addEventListener('change', function(event) {
    if (event.target.matches('.qtyField input.qty')) {
        hmClampQuantityInput(event.target);
    }
}, true);

document.addEventListener('blur', function(event) {
    if (event.target.matches('.qtyField input.qty')) {
        hmClampQuantityInput(event.target);
    }
}, true);

function copyToClipboard(elem) {
    var target      = elem;
    var currentFocus= document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);
    var succeed;
    try {
        succeed     = document.execCommand("copy");
    } catch (e) {
        succeed     = false;
    }
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }
    jQuery(".copy-copied").animate({ top: -30 }, 700, function() { 
        setTimeout(function(){
            jQuery(".copy-copied").animate({ opacity: 0 }, 100, function() {  
                setTimeout(function(){
                    jQuery(".copy-copied").css({ top: 0, opacity: 1 }); 
                }, 100); 
            }); 
        }, 1000); 
    }); 
}

function updateProductVariantsField() {
    if (typeof window.jQuery === 'undefined') {
        return;
    }
    var $field = window.jQuery('input[name=product_variants]');
    if (!$field.length) {
        return;
    }
    var aggregated = {};
    window.jQuery('input.package-input').each(function () {
        var name = window.jQuery(this).attr('name') || '';
        var match = name.match(/\[(\d+)\]/);
        if (!match) {
            return;
        }
        var packageId = match[1];
        var val = window.jQuery(this).val();
        if (val) {
            aggregated[packageId] = val;
        }
    });
    $field.val(JSON.stringify(aggregated));
}

if (typeof window !== 'undefined' && typeof window.updateProductVariantsField !== 'function') {
    window.updateProductVariantsField = updateProductVariantsField;
}

document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.reset-product-options');
    if (!trigger) {
        return;
    }
    event.preventDefault();
    window.location.reload();
});

function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
  
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
}
 
function bottomCartClose(open) {
    const bottomCart    = document.querySelector('.bottom-cart')
    const body          = document.querySelector('body');
    if(bottomCart){
        if (open == true) {
            bottomCart.classList.remove('hide')
            bottomCart.classList.add('show')
            body.classList.add('cart-bar')
        } else {
            bottomCart.classList.add('hide')
            bottomCart.classList.remove('show')
            body.classList.remove('cart-bar')
            setCookie('cartbottom', 'true', 365);   
        }
    }
    return false;
}

function base64ToUtf8(str) {
    try {
        return decodeURIComponent(escape(window.atob(str)));
    } catch (e) {
        console.error('Base64 decode error:', e);
        return '';
    }
}

function setVariantOptionAvailability($option, available) {
    var label = $option.attr('data-option-label') || '';
    var unavailableLabel = $option.attr('data-unavailable-label') || '';
    var title = label + (!available && unavailableLabel ? ' – ' + unavailableLabel : '');
    $option.prop('disabled', !available).attr('aria-disabled', String(!available));
    if ($option.is('option')) {
        if (label) $option.text(title);
        return;
    }

    $option.attr('aria-label', title);
    var $swatch = $option.closest('.swatch');
    $swatch.toggleClass('soldout', !available)
        .attr('aria-label', title)
        .attr('data-bs-original-title', title);
    $option.closest('label, .radio').find('.variant-availability').toggleClass('d-none', available);
    if (!available) {
        $option.prop('checked', false);
        $swatch.removeClass('active');
    }
}

function compatible(variant, selections, ignoreAttrId) {
    var ok = true;
    var opts = variant.options || {};
    for (var aid in selections) {
        if (!selections.hasOwnProperty(aid)) continue;
        if (ignoreAttrId && String(ignoreAttrId) === String(aid)) continue;
        var val = selections[aid];
        if (!val) continue;
        if (!opts.hasOwnProperty(aid)) { ok = false; break; }
        if (String(opts[aid]) !== String(val)) { ok = false; break; }
    }
    return ok;
}

function initMap() { 
    if (jQuery('#google-map').length) { 
        $('#google-map .show-map').on("click", function(e) {    
            var mapLat		= jQuery('#google-map').data('map-lat');
            var mapLng		= jQuery('#google-map').data('map-lng');
            var iconPath	= jQuery('#google-map').data('map-icon');
            var mapZoom		= jQuery('#google-map').data('map-zoom');
            var mapTitle	= jQuery('#google-map').data('map-title');  
            var mapId	    = jQuery('#google-map').data('map-id');  
            var center      = { lat: parseFloat(mapLat), lng: parseFloat(mapLng) };
            var map         = new google.maps.Map(document.getElementById('google-map'), {
                center: center,
                zoom: mapZoom, 
                scrollwheel: false,
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                cameraControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false, 
                mapId: mapId,
            });
            map.panBy(50, -30); 
            const markerIcon = document.createElement('img');
            markerIcon.src = iconPath; 
            const marker = new google.maps.marker.AdvancedMarkerElement({
                position: center,
                map: map,
                content: markerIcon,
                title: mapTitle,
            });
            marker.addListener("click", () => {
                const googleMapsUrl = 'https://www.google.com/maps?q=' + mapLat + ',' + mapLng;
                window.open(googleMapsUrl, "_blank"); 
            });
        });
    }
}

window.initMap = initMap;

if (window.google && window.google.maps) {
    initMap();
}
  
function checkRadio(){
    jQuery("input[name=payment_value]").val('');
    jQuery("input[name=payment_price]").val('');
    if (!jQuery("#shipping-options .radio input:radio:checked").val()) {
        jQuery('#shipping-options .shipping-options-method:first-child .radio input:radio').prop('checked', true).attr('checked', true).change();
    }
    jQuery('.shipping-option-tips').hide();
    jQuery('#shipping-options .radio input:radio').each(function() {
        if (jQuery(this).is(":checked")){
            jQuery(this).closest('.shipping-options-method').find('.shipping-option-tips').show();
            jQuery(this).closest('.shipping-options-method').addClass('active');
        }else{
            jQuery(this).closest('.shipping-options-method').removeClass('active');
        }
    });
    var $this = jQuery("#shipping-options .radio input:radio:checked");
    jQuery("input[name=shipping_value]").val( $this.attr('data-id') );
    jQuery("input[name=shipping_price]").val( $this.attr('data-price') );
    setParcelShopRequired();
    loadPayments();
}

function loadPayments(){ 
    var delivery_id = jQuery("#shipping-options .radio input:radio:checked").val();
    jQuery.post(shopurl + "checkout/payments", { ajax: '1', delivery_id: delivery_id }, function(data) {
        jQuery('#payments-rates-list').html(data); 
        checkPaymentRadio();
    });
}

function checkPaymentRadio(){
    if (!jQuery("#payments-rates-list .radio input:radio:checked").val()) {
        jQuery('#payments-rates-list .payment-options-method:first-child .radio input:radio').prop('checked', true).attr('checked', true).change();
    }
    jQuery('.payment-option-tips').hide();
    jQuery('#payments-rates-list .radio input:radio').each(function() {
        if (jQuery(this).is(":checked")){
            jQuery(this).closest('.payment-options-method').find('.ty-checkout__payment-tips').show();
            jQuery(this).closest('.payment-options-method').addClass('active');
        }else{
            jQuery(this).closest('.payment-options-method').removeClass('active');
        }
    });
    var $this = jQuery("#payments-rates-list .radio input:radio:checked");
    jQuery("input[name=payment_value]").val( $this.attr('data-id') );
    jQuery("input[name=payment_price]").val( $this.attr('data-price') );
}

function getSelectedShippingOptionWrapper() {
    if (typeof window.jQuery === 'undefined') {
        return null;
    }

    return jQuery('#shipping-options .radio input:radio:checked')
        .closest('.shipping-options-method')
        .find('.shipping-option-tips');
}

function setParcelShopRequired() {
    if (typeof window.jQuery === 'undefined') {
        return;
    }

    var $wrappers = jQuery('#shipping-options .shipping-option-tips');
    var $selectedWrapper = getSelectedShippingOptionWrapper();
    var $requiredFields = $wrappers.find('.parcel-shop-title, input[name="dispensing_point"]');

    $wrappers.find('input, select, textarea').prop('disabled', true);
    $requiredFields.prop('required', false).removeAttr('required');

    if (!$selectedWrapper || !$selectedWrapper.length) {
        return;
    }

    $selectedWrapper.find('input, select, textarea').prop('disabled', false);
    $selectedWrapper.find('.parcel-shop-title, input[name="dispensing_point"]').prop('required', true).attr('required', 'required');
}

function clearParcelShopFields() {
    if (typeof window.jQuery === 'undefined') {
        return;
    }

    jQuery('#shipping-options .shipping-option-tips input[name^="parcel-shop"], #shipping-options .shipping-option-tips input[name="dispensing_point"]').val('');
    jQuery('#shipping-options .wrapper-parcel_shop_sps .parcel-shop-service').val('sps');
}

var parcelShopSpsCurrentWrapper = null;

function getParcelShopSpsWrapper(element) {
    if (typeof window.jQuery === 'undefined') {
        return null;
    }

    var $wrapper = element ? jQuery(element).closest('.wrapper-parcel_shop_sps') : jQuery();

    if (!$wrapper.length) {
        $wrapper = jQuery('#shipping-options .radio input[data-custom="parcel_shop_sps"]:checked')
            .closest('.shipping-options-method')
            .find('.wrapper-parcel_shop_sps');
    }

    if (!$wrapper.length) {
        $wrapper = jQuery('.wrapper-parcel_shop_sps').first();
    }

    return $wrapper;
}

function getParcelShopSpsWidgetParams($wrapper) {
    var $config = $wrapper.find('.sps-widget-config');
    var country = String($config.data('country') || 'SK').toUpperCase();
    var address = String($config.data('address') || '');
    var selectedCode = String($wrapper.find('.parcel-shop-code').val() || '');
    var params = {
        country: country === 'CZ' ? 'CZ' : 'SK',
        ps: '1'
    };

    if (address) {
        params.address = address;
    }

    if (selectedCode) {
        params.name = selectedCode;
    }

    return params;
}

function loadParcelShopSpsWidget($wrapper) {
    var mapElement = document.getElementById('osmMap');

    if (!mapElement || !$wrapper || !$wrapper.length) {
        return;
    }

    var scriptId = 'sps-balikovo-widget-script';
    var oldScript = document.getElementById(scriptId);
    var params = getParcelShopSpsWidgetParams($wrapper);
    var query = Object.keys(params).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
    var script = document.createElement('script');

    if (oldScript) {
        oldScript.parentNode.removeChild(oldScript);
    }

    mapElement.innerHTML = '';
    script.id = scriptId;
    script.src = 'https://balikomat.sps-sro.sk/widget/v1/widget/php/csv_to_google_map_location.php?' + query;
    document.head.appendChild(script);
}

function resizeParcelShopSpsWidget() {
    if (typeof window.jQuery === 'undefined') {
        return;
    }

    var contentHeight = Math.max(jQuery(window).height() - 30, 520);
    var mapHeight = Math.max(jQuery(window).height() - 125, 420);

    jQuery('#parcelShopSps .modal-dialog .modal-content').height(contentHeight).css('margin-top', 0);
    jQuery('#parcelShopSps #osmMap').height(mapHeight);
}

function openParcelShopSpsWidget(trigger) {
    if (typeof window.jQuery === 'undefined') {
        return;
    }

    var $modal = jQuery('#parcelShopSps');
    var $wrapper = getParcelShopSpsWrapper(trigger);

    if (!$modal.length || !$wrapper || !$wrapper.length) {
        return;
    }

    parcelShopSpsCurrentWrapper = $wrapper;
    resizeParcelShopSpsWidget();
    var loaded = false;
    var loadWidget = function () {
        if (loaded) {
            return;
        }

        loaded = true;
        resizeParcelShopSpsWidget();
        loadParcelShopSpsWidget($wrapper);
    };

    $modal.one('shown.bs.modal', loadWidget);

    hmShowModal($modal[0]);
    setTimeout(loadWidget, 350);
}

function closeParcelShopSpsWidget() {
    if (typeof window.jQuery === 'undefined') {
        return;
    }

    var $modal = jQuery('#parcelShopSps');

    if (!$modal.length) {
        return;
    }

    hmHideModal($modal[0]);
}

function setParcelShopSpsField(id, value) {
    var field = document.getElementById(id);

    if (!field) {
        return;
    }

    field.disabled = false;
    field.value = value || '';
    field.dispatchEvent(new Event('input', {bubbles: true}));
    field.dispatchEvent(new Event('change', {bubbles: true}));
}

function setParcelShopSpsPoint(point) {
    if (!point) {
        return;
    }

    var title = point.description || point.name || point.id || '';
    var displayTitle = [
        title,
        point.address || '',
        [point.zip || '', point.city || ''].join(' ').trim()
    ].filter(Boolean).join(', ');

    var fillFields = function () {
        setParcelShopSpsField('sps_parcel_shop_code', point.id || '');
        setParcelShopSpsField('sps_parcel_shop_title', displayTitle || title);
        setParcelShopSpsField('sps_parcel_shop_address', point.address || '');
        setParcelShopSpsField('sps_parcel_shop_city', point.city || '');
        setParcelShopSpsField('sps_parcel_shop_zip', point.zip || '');
        setParcelShopSpsField('sps_parcel_shop_country', point.countryISO || '');
        setParcelShopSpsField('sps_parcel_shop_service', 'sps');
        setParcelShopSpsField('sps_parcel_shop_type', point.type || '');
    };

    fillFields();

    var $wrapper = parcelShopSpsCurrentWrapper && parcelShopSpsCurrentWrapper.length ? parcelShopSpsCurrentWrapper : getParcelShopSpsWrapper();

    if ($wrapper && $wrapper.length) {
        $wrapper.find('input, select, textarea').prop('disabled', false);
        $wrapper.find('.parcel-shop-code').val(point.id || '');
        $wrapper.find('.parcel-shop-title').val(displayTitle || title).trigger('input').trigger('change');
        $wrapper.find('.parcel-shop-address').val(point.address || '');
        $wrapper.find('.parcel-shop-city').val(point.city || '');
        $wrapper.find('.parcel-shop-zip').val(point.zip || '');
        $wrapper.find('.parcel-shop-country').val(point.countryISO || '');
        $wrapper.find('.parcel-shop-service').val('sps');
        $wrapper.find('.parcel-shop-type').val(point.type || '');
    }

    closeParcelShopSpsWidget();
    setTimeout(fillFields, 100);
    setTimeout(fillFields, 400);

    if (typeof window.CustomEvent === 'function') {
        window.dispatchEvent(new CustomEvent('spsParcelShopSelected', {detail: point}));
    }
}

function FillBoxMachine3(point) {
    setParcelShopSpsPoint(point);
}

function getParcelShopSpsPointFromMessage(event) {
    if (!parcelShopSpsCurrentWrapper || !parcelShopSpsCurrentWrapper.length || !document.getElementById('balikovo')) {
        return null;
    }

    var message = event.data;

    if (typeof message === 'string') {
        try {
            message = JSON.parse(message);
        } catch (e) {
            return null;
        }
    }

    if (!message) {
        return null;
    }

    if (message.command === 'close') {
        message = message.data;
    }

    if (!message || (!message.id && !message.description && !message.address)) {
        return null;
    }

    return message;
}

if (typeof window !== 'undefined') {
    window.FillBoxMachine3 = FillBoxMachine3;

    window.addEventListener('message', function (event) {
        var point = getParcelShopSpsPointFromMessage(event);

        if (point) {
            setParcelShopSpsPoint(point);
        }
    });
}

document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.open-parcel-shop-sps');

    if (!trigger) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof window.jQuery !== 'undefined') {
        var $method = jQuery(trigger).closest('.shipping-options-method');
        var $radio = $method.find('.radio input[name="shipping-option"]');

        if ($radio.length && !$radio.prop('checked')) {
            $radio.prop('checked', true).attr('checked', true).trigger('change');
        } else {
            setParcelShopRequired();
        }
    }

    openParcelShopSpsWidget(trigger);
}, true);

function calculateCarton(form){
    var quantityInput = form.find('[name=input-quantity]');
    var cartonInput = form.find('[name=input-carton]');
    var maximumAttribute = form.attr('data-max-quantity');
    var maximum = maximumAttribute === undefined || maximumAttribute === '' ? null : Number(maximumAttribute);
    if (maximum !== null && Number.isFinite(maximum)) {
        cartonInput.attr('max', maximum);
        if (cartonInput.length) hmClampQuantityInput(cartonInput[0]);
        var packSize = cartonInput.length ? Math.max(1, Number(form.find('[name=pack_qty]').val()) || 1) : 1;
        var cartonQuantity = cartonInput.length ? Number(cartonInput.val()) || 0 : 0;
        quantityInput.attr('max', Math.max(0, (maximum - cartonQuantity) * packSize));
    } else {
        quantityInput.removeAttr('max');
        cartonInput.removeAttr('max');
    }
    if (quantityInput.length) hmClampQuantityInput(quantityInput[0]);
    if (form.find('[name=input-carton]').length && form.find('[name=input-quantity]').length){  
        var current_qty = Number(form.find('[name=input-quantity]').val());
        if (current_qty < 0) {
            current_qty = 0;
            form.find('[name=input-quantity]').val(0); 
        } 
        var quantity    = current_qty;
        var carton_qty  = Number(form.find('[name=input-carton]').val());
        var qty         = Number(form.find('[name=input-quantity]').val());   
        var pack_qty    = Number(form.find('[name=pack_qty]').val());
        if (pack_qty > 1 && qty > 0) {
            qty         = qty / pack_qty;
        } 
        var quantity    = carton_qty + qty;  
        form.find('.qty_text').show().find('span').html(number_format(quantity, 2));
        form.find('[name=qty]').val(quantity); 
    }else{  
        if (form.find('[name=input-carton]').length){ 
            form.find('[name=qty]').val(Number(form.find('[name=input-carton]').val()));
        }else{
            form.find('[name=qty]').val(Number(form.find('[name=input-quantity]').val()));
        } 
    } 
}
 
function getCompanyCountryCode() {
    var countryCode = jQuery('select[name=country] option:selected').data('code');
    return countryCode ? String(countryCode).toLowerCase() : '';
}

function setCompanyFieldRequired(field, required) {
    if (required) {
        field.attr('required', 'required').addClass('required');
        return;
    }

    field.removeAttr('required').removeClass('required');
}

function updateCompanyCheckoutFields() {
    var companyFields = jQuery('.checkout-address .company-type');
    if (!companyFields.length) {
        return;
    }

    var form = companyFields.closest('form');
    var validator = form.data('bs.validator');
    var isCompanyPurchase = jQuery('#company-purchase').is(':checked');
    var companyType = jQuery('select[name=company_type]').val();
    var selectedCountry = getCompanyCountryCode();
    var shopCompany = String(companyFields.data('shop-company') || 'sk').toLowerCase();

    if (!isCompanyPurchase) {
        jQuery('select[name=company_type]').val('1');
        companyType = '1';
    }

    companyFields.find('[data-company-required]').each(function () {
        var field = jQuery(this);
        var rule = field.data('company-required');
        var required = false;

        if (isCompanyPurchase) {
            required = rule === 'base' ||
                (rule === 'sk' && selectedCountry === shopCompany) ||
                (rule === 'vat' && companyType === '2');
        }

        setCompanyFieldRequired(field, required);
        if (!required && validator && typeof validator.clearErrors === 'function') {
            field.removeData(['bs.validator.errors', 'bs.validator.deferred']);
            validator.clearErrors(field);
        }
    });

    jQuery('.company-vat-required').toggleClass('d-none', !(isCompanyPurchase && companyType === '2'));

    if (jQuery.fn.validator && validator) {
        form.validator('update');
    }
}

function toggleCompanyCheckoutFields() {
    var isCompanyPurchase = jQuery('#company-purchase').is(':checked');
    jQuery('.checkout-address .company-type').toggleClass('d-none', !isCompanyPurchase);
    updateCompanyCheckoutFields();
}

function updateCompanyType() {
    if (jQuery('#company-purchase').is(':checked') && jQuery('#company-icdph').val()) {
        jQuery('select[name=company_type]').val('2');
    }

    updateCompanyCheckoutFields();
}

function clearShippingAddressValidation() {
    var form = jQuery('.checkout-address form');
    var validator = form.data('bs.validator');

    if (!validator || typeof validator.clearErrors !== 'function') {
        return;
    }

    jQuery('.shipping-address').find('input, select').each(function () {
        var field = jQuery(this);
        field.removeData(['bs.validator.errors', 'bs.validator.deferred']);
        validator.clearErrors(field);
    });

    if (jQuery.fn.validator) {
        form.validator('update');
    }
}

function setShippingAddressRequired(required) {
    var fields = jQuery('.shipping-address input.required, .shipping-address select.required');

    if (required) {
        fields.attr('required', 'required');
    } else {
        fields.removeAttr('required');
    }

    clearShippingAddressValidation();
}

function clearShippingAddressCountry() {
    jQuery('.shipping-address select').val('');
}

function fillShippingAddressDefaults() {
    jQuery('.shipping-address input, .shipping-address select').each(function() {
        var elementItem = jQuery(this);
        var defaultValue = elementItem.data('default');

        if (elementItem.val() == '' && defaultValue) {
            elementItem.val(defaultValue);
        }
    });
}

function paymentMethodChanged() {
    var $order_review = $(".payment-method");
    $order_review.on("click", 'input[name="payment_method"]', function () {
        var selectedClass = "payment-selected";
        var parent = $(this).parents(".sin-payment").first();
        parent.addClass(selectedClass).siblings().removeClass(selectedClass);
    });
}

function number_format (number, decimals, dec_point, thousands_sep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
    
function recalculate(show){  
    jQuery('input.number, button.number').on('click, change, keyup', function (e) {
        jQuery('button.ty-btn.recalculate').fadeIn();
    }); 	
    if(show){
        jQuery('button.ty-btn.recalculate').fadeIn(); 
    }
}

function adaptiveElementsHeight(){  
    adaptiveHeight('section.contact h3');    
}

function adaptiveHeight(element, parent) {
    if(parent){ 
        jQuery(element).height(jQuery(parent).height()); 
    } else {
        if (jQuery(element).length) {
            jQuery(element).css("height", "auto");
            var max = -1;
            jQuery(element).each(function() {
                var h = jQuery(this).height();
                max = h > max ? h : max;
            });
            jQuery(element).height(max);
        }
    }
}

function ajax_messages_hide(){
    $('#notifications .flash').fadeOut("slow");
    jQuery('.swal-overlay').fadeOut( "slow", function() {
        jQuery('.swal-overlay').remove();  
    });
}

(function ($) {
    $(function() {

    function updateQuatroCalculatorButton() {
        var $button = $('.quatro-calculator-trigger');
        if (!$button.length) {
            return;
        }

        var $slot = $button.closest('.quatro-calculator-slot');
        var $price = $('.product-single .product-price [data-quatro-price]').first();
        var amount = parseFloat($price.attr('data-quatro-price'));
        var calculatorUrl = $price.attr('data-quatro-url') || '';
        var isAvailable = isFinite(amount) && amount >= 100 && calculatorUrl !== '';

        $button.attr('data-quatro-price', isAvailable ? amount.toFixed(2) : '');
        $button.attr('data-quatro-url', isAvailable ? calculatorUrl : '');
        $slot.toggleClass('d-none', !isAvailable);
    }

    updateQuatroCalculatorButton();

    var quatroCalculatorModal = document.getElementById('quatro-calculator-modal');
    if (quatroCalculatorModal) {
        var quatroCalculatorFrame = quatroCalculatorModal.querySelector('.quatro-calculator-modal__frame');
        quatroCalculatorModal.addEventListener('show.bs.modal', function(event) {
            var trigger = event.relatedTarget;
            var calculatorUrl = trigger ? trigger.getAttribute('data-quatro-url') : '';
            if (quatroCalculatorFrame && calculatorUrl) {
                quatroCalculatorFrame.setAttribute('src', calculatorUrl);
            }
        });
        quatroCalculatorModal.addEventListener('hidden.bs.modal', function() {
            if (quatroCalculatorFrame) {
                quatroCalculatorFrame.setAttribute('src', 'about:blank');
            }
        });
    }
   
    $(document).on('click', '.item.col-item .swatchLbl', function (e) {
        e.preventDefault(); 
        const newImage = $(this).data('image'); 
        if(newImage){
            const item = $(this).closest('.item'); 
            item.find('.product-image img.primary').attr('src', newImage);
            item.find('.product-image img.hover').attr('src', newImage);
        }
    });

    $(".copy-button, .copy-target").on("click", function() { 
        copyToClipboard(document.getElementById("copy-target"));
    });
       
    if ($.fn.validator) {
        $('.validator, .validate').validator({
            disable: false,
        });
    }
 
    if($('#newsletter_modal').length){
        if($('#newsletter_modal').length && !getCookie('newsletter_hide')) {
            var showNewsletterModal = function() {
                setTimeout(function() {
                    hmShowModal('#newsletter_modal');
                }, 7000);
            };

            if (typeof window.hmAfterFirstInteraction === 'function') {
                window.hmAfterFirstInteraction(showNewsletterModal);
            } else {
                showNewsletterModal();
            }
        }
        $('#newsletter_modal').on('hide.bs.modal', function () { 
            if($("#dontshow").is(':checked')) { 
                setCookie('newsletter_hide', '1', 365);  
            }
        });
    }

    if ($('.bottom-cart__close').length) { 
        $('.bottom-cart__close').on('click', function () {
            bottomCartClose();
        }); 
        if (getCookie('cartbottom')) {
            bottomCartClose(false);
        } else {
            bottomCartClose(true);
        }
    }

    var minisearchInput = jQuery('.minisearch input[name="q"]');

    function renderSearchAutocompleteItem(ul, item) {
        if(item.type == 'product'){
            if(item.link){
                var html = '<div class="d-flex align-items-center">';
                    html += '<div class="img"><img src="'+item.image+'"></div>';
                    html += '<div class="autocomplete-item-text">';
                        html += '<b class="title">'+item.label+'</b>';
                    html += '</div>';
                html += '</div>';
                return jQuery("<li>").append(html).appendTo(ul);
            }else{
                return jQuery("<li>").append('<span class="title">'+item.label+'</span>').appendTo(ul);
            }
        }else if(item.type == 'category'){
            if(item.link){
                var html = '<div class="d-flex align-items-center">';
                    html += '<div class="img"><img src="'+item.image+'"></div>';
                    html += '<div class="autocomplete-item-text">';
                        html += '<b class="title">'+item.label+'</b>';
                    html += '</div>';
                html += '</div>';
                return jQuery("<li>").append(html).appendTo(ul);
            }else{
                return jQuery("<li>").append('<span class="title">'+item.label+'</span>').appendTo(ul);
            }
        }
    }

    function showSearchAutocomplete(input, autocompleteBox, autocompleteHelp) {
        autocompleteBox.show();

        if (input.val().length >= 3) {
            autocompleteHelp.hide();
            input.autocomplete('search');
            return;
        }

        autocompleteHelp.show();
        autocompleteBox.find('.ui-autocomplete').not('.autocomplete-help').hide();
    }

    function initSearchAutocomplete() {
        if (!minisearchInput.length || !jQuery.fn.autocomplete) {
            return;
        }

        minisearchInput.each(function() {
            var input = jQuery(this);
            var form = input.closest('.minisearch');
            var autocompleteBox = form.find('.autocomplete').first();
            var autocompleteHelp = autocompleteBox.find('.autocomplete-help').first();

            if (input.data('hm-autocomplete-ready') || !autocompleteBox.length) {
                return;
            }

            input.data('hm-autocomplete-ready', true);
            input.autocomplete({
                minLength: 3,
                delay: 0,
                appendTo: autocompleteBox[0],
                source: function(request, response) {
                    jQuery.ajax({
                        dataType: 'json',
                        url:  shopurl + 'api/autocomplete_search',
                        data: {
                            term: request.term,
                        },
                        success: function(data) {
                            response(data);
                            autocompleteHelp.hide();
                            autocompleteBox.show();
                        },
                        error: function() {
                            response([]);
                            autocompleteBox.hide();
                        },
                    });
                },
                search: function() {
                    autocompleteHelp.hide();
                    autocompleteBox.show();
                },
                select: function(event, ui) {
                    autocompleteBox.hide();
                    window.location.href = ui.item.link;
                }
            }).on('focus.hmAutocomplete', function() {
                showSearchAutocomplete(input, autocompleteBox, autocompleteHelp);
            }).on('input.hmAutocomplete', function() {
                autocompleteBox.show();

                if (input.val().length < 3) {
                    autocompleteHelp.show();
                    autocompleteBox.find('.ui-autocomplete').not('.autocomplete-help').hide();
                    return;
                }

                autocompleteHelp.hide();
            });

            var minisearchAutocomplete = input.autocomplete("instance");
            if (minisearchAutocomplete) {
                minisearchAutocomplete._renderItem = renderSearchAutocompleteItem;
            }

            if (input[0] === document.activeElement) {
                showSearchAutocomplete(input, autocompleteBox, autocompleteHelp);
            }
        });
    }

    window.hmInitSearchAutocomplete = initSearchAutocomplete;

    function loadSearchAutocomplete() {
        if (window.hmLoadAssetStyle) {
            window.hmLoadAssetStyle(window.hmAssets && window.hmAssets.searchAutocompleteStyle);
        }

        hmLoadScript(window.hmAssets && window.hmAssets.searchAutocomplete, initSearchAutocomplete);
    }

    if (minisearchInput.length && jQuery.fn.autocomplete) {
        if (window.hmLoadAssetStyle) {
            window.hmLoadAssetStyle(window.hmAssets && window.hmAssets.searchAutocompleteStyle);
        }
        initSearchAutocomplete();
    } else if (minisearchInput.length) {
        jQuery(document).on('focusin.hmAutocompleteHelp', '.minisearch input[name="q"]', function() {
            var input = jQuery(this);
            var autocompleteBox = input.closest('.minisearch').find('.autocomplete').first();
            var autocompleteHelp = autocompleteBox.find('.autocomplete-help').first();

            if (input.data('hm-autocomplete-ready') || !autocompleteBox.length || input.val().length >= 3) {
                return;
            }

            autocompleteBox.show();
            autocompleteHelp.show();
            autocompleteBox.find('.ui-autocomplete').not('.autocomplete-help').hide();
        });
        minisearchInput.one('focus.hmAutocomplete input.hmAutocomplete', function() {
            loadSearchAutocomplete();
        });
    }

	$(document).click(function(event) {
		var $target = $(event.target);
		if(!$target.closest('.minisearch').length) {
			$('.minisearch .autocomplete').hide();
		}        
	});

    $("#filter input[type=checkbox]").on("click", function (e) {
        //e.preventDefault(); 
        window.location.href = $(this).data('url');     
    });

    if ($.fn.magnificPopup) {
        $(".img-popup").magnificPopup({
            type: "image",
            gallery: {
                enabled: true
            }
        });
    }

    paymentMethodChanged();

    jQuery('.alert-messages').hide(); 
 
    if(jQuery('.alert-messages .alert').length){  
        var element = jQuery('.alert-messages .alert');
        var type	= element.data('type');
        if(element.text()){
            hmShowAlert({
                title: "",
                text: element.text(),
                icon: type,
                button: false,
                timer: 10000
            });
        }	
    } 
            
    jQuery('.open-print').click(function(){
        window.print();
        return false;
    });
    
    jQuery(window).bind('resize', function() {
        adaptiveElementsHeight(); 
    });

    adaptiveElementsHeight(); 
    
    jQuery(window).on('load', function(){ 
        jQuery('.page-preloader').fadeOut();
        adaptiveElementsHeight();
    });
  
    if($('#notifications .flash').length>0){
        setInterval(function(){
            ajax_messages_hide();
        }, 5000);
    }
    
    if (window.noUiSlider && window.wNumb) {
    $(".js-range-slider, #slider-range").each(function () {
        var rangeSlider = this;
        if (rangeSlider.noUiSlider) {
            return;
        }

        var decimals = parseInt(rangeSlider.dataset.decimals || 0, 10);
        var postfix = typeof rangeSlider.dataset.postfix !== 'undefined' ? rangeSlider.dataset.postfix : currency;
        var rangeFormat = wNumb({
            decimals: decimals,
            thousand: " ",
            prefix: "",
            postfix: postfix
        });
        var min = parseFloat(rangeSlider.dataset.min);
        var max = parseFloat(rangeSlider.dataset.max);
        var startMin = parseFloat(rangeSlider.dataset.curmin);
        var startMax = parseFloat(rangeSlider.dataset.curmax);
        var step = parseFloat(rangeSlider.dataset.step || 1);

        if (isNaN(min) || isNaN(max) || isNaN(startMin) || isNaN(startMax)) {
            return;
        }

        noUiSlider.create(rangeSlider, {
            start: [startMin, startMax],
            step: step,
            range: {
                min: [min],
                max: [max]
            },
            format: rangeFormat,
            connect: true
        });
        rangeSlider.noUiSlider.on("update", function (values) {
            var outputFrom = document.getElementById(rangeSlider.dataset.outputFrom || "slider-range-from");
            var outputTo = document.getElementById(rangeSlider.dataset.outputTo || "slider-range-to");
            var inputMin = document.getElementById(rangeSlider.dataset.inputMin || "price-min");
            var inputMax = document.getElementById(rangeSlider.dataset.inputMax || "price-max");

            if (outputFrom) {
                outputFrom.innerHTML = values[0];
            }
            if (outputTo) {
                outputTo.innerHTML = values[1];
            }
            if (inputMin) {
                inputMin.value = rangeFormat.from(values[0]);
            }
            if (inputMax) {
                inputMax.value = rangeFormat.from(values[1]);
            }
        });
        rangeSlider.noUiSlider.on('change.one', function () {
            var form = document.getElementById(rangeSlider.dataset.form || "filter-price");
            if (form) {
                form.submit();
            }
        });
    });
    }
 
	$("body").on("change", ".product-filter input[type=checkbox]", function(e) {   
        window.location.href = $(this).data('url');
    });
     
    $('[name=input-quantity]').change(function () {
        var form = $(this).closest('form');
        var current_qty = Number(form.find('[name=input-quantity]').val());   
		var minimum_qty = Number(form.find('[name=minimum]').val());
        var carton_qty  = Number(form.find('[name=input-carton]').val());
		if (current_qty >= minimum_qty && minimum_qty > 1) {
            $(this).val(0); 
            form.find('[name=input-carton]').val(carton_qty + 1); 
        } 
        calculateCarton(form);  
    });
    
    $('[name=input-carton]').change(function () {
        calculateCarton($(this).closest('form'));
    });
   
    $(".product-filter").on("click", ".show-more", function(e) { 
        e.preventDefault();
        var showElement = $(this); 
        showElement.addClass('d-none');
        showElement.parent().find('.show-less').removeClass('d-none');
        showElement.parent().find('.filter-value.hide').removeClass('d-none');
    });
    
    $(".product-filter").on("click", ".show-less", function(e) { 
        e.preventDefault();
        var showElement = $(this); 
        showElement.addClass('d-none');
        showElement.parent().find('.show-more').removeClass('d-none');
        showElement.parent().find('.filter-value.hide').addClass('d-none');
    });
      
	$("body").on("click", "a.add-cart, button.add-cart", function(e) {    
		var $this 			= $(this);
		var grouped        	= {};
		var variants        = ''; 
		var package_variants= ''; 
        if ($this.data("id")) { 
            var qty         = 1;
            var product_id  = $this.data("id");
            var variants 	= $this.data("variant"); 
            var loyalty 	= $this.data("loyalty");  
            var add_element = $this.closest('div.add-cart');
            if(add_element && add_element.find('.qty-val').val() > 0){
                var qty     = add_element.find('.qty-val').val();
            } 
        }else{
            var form 			    = $this.closest("form");
            calculateCarton(form);
            var qty                 = form.find("input[name=qty]").val();
            var product_id          = form.find("input[name=product_id]").val();
            var variants 	        = form.find("input[name=product_variant]").val();
            var package_variants 	= form.find("input[name=product_variants]").val();
            form.find('.group_table td.buy .checkbox input[type="checkbox"]:checked').each(function() {
                grouped[this.value] = this.value;
            });
        }
		var params = {
			product_id: product_id,
			quantity: qty,
			variant: variants,
			package: package_variants,
			loyalty: loyalty,
			grouped: grouped, 
			product_price: 0,  
			ajax: '1',
		};  
		$this.addClass('loading');
		$('.ajax').show(); 
        if( qty > 0 ){
            $.post(shopurl + "cart/add_product", params, function(data) {  
                json = $.parseJSON(data); 
                msg  = json && typeof json === 'object' && json['msg'] ? json['msg'] : "";
                if (json && typeof json === 'object' && Object.prototype.hasOwnProperty.call(json, 'status')){
                    data = json['status'];
                    msg  = json['msg'] ? json['msg'] : "";
                }
                data = $.trim(data);
                if(data == 'true'){  
   
                    $.post(shopurl + "cart/cart_mini_show", {},  function(response){
                        response = $.parseJSON(response); 
                        $("#minicart-drawer").html(response.cart);  
                        $(".bottom-cart").html(response.cart_bottom); 
                        var cartCount = Number(response.cart_count) || 0;
                        $(".cart-count").text(cartCount > 9 ? '9+' : cartCount);
                        $(".header-cart-total").text(response.cart_total);  
                    });

                    $.post(shopurl + "cart/show_cart_popup", {},  function(response){
                        $("#addtocart_modal #product-form-addtocart").html(response); 
                        hmShowModal('#addtocart_modal');
                    });
                    
                    if (typeof fbq !== 'undefined' && $.isFunction(fbq)){
                        fbq('track', 'AddToCart');
                    }  
                }else if (data == 'not_at_stock'){
                    window.location.replace(shopurl + "produkt/" + id);
                    hmShowAlert({
                        title: "",
                        text: lang.product_out_of_stock,
                        icon: 'error',
                        button: false,
                        timer: 4000
                    }); 
                    $('.ajax').hide();
                }else{
                    hmShowAlert({
                        title: "",
                        text: msg || lang.product_not_exist,
                        icon: 'error',
                        button: false,
                        timer: 4000
                    }); 
                    $('.ajax').hide();
                }  
                $this.removeClass('loading');
            });
        }else{
            hmShowAlert({
                title: "",
                text: lang.must_enter_quantity,
                icon: 'error',
                button: false,
                timer: 4000
            }); 
        }
		e.preventDefault();
	});
 
    $("body").on("click", ".recalculate", function(e) {
        let cartForm = document.getElementById('cart_update');
        if (cartForm) {
            cartForm.submit();
        }
        e.preventDefault();
    });
    
    var cartUpdateTimer = null;
    $("body").on("change", "#cart_update .qtyField input.qty:not([readonly])", function(e) {
        hmClampQuantityInput(this);
        clearTimeout(cartUpdateTimer);
        cartUpdateTimer = setTimeout(function() {
            let cartForm = document.getElementById('cart_update');
            if (cartForm) {
                cartForm.submit();
            }
        }, 2000); 
    });

    $('.qtyField input.qty').each(function() {
        hmClampQuantityInput(this);
    });
    $('.product-form').each(function() {
        calculateCarton($(this));
    });
    
    if($('.checkout-address').length){ 
         
        updateCompanyType();
        $('#company-purchase').on('change', toggleCompanyCheckoutFields);
        $('select[name=country], select[name=company_type]').on('change', updateCompanyCheckoutFields);
        $('#company-icdph').on('input change', updateCompanyType); 
        setInterval(updateCompanyType, 5000); 

        $('input[name=different]').on( "change", function() { 
            var element = $(this);  
            if (element.val()!=1) {
                setShippingAddressRequired(false);
                $('.shipping-address').addClass('hidden');
                clearShippingAddressCountry();
            } else {
                $('.shipping-address').removeClass('hidden'); 
                fillShippingAddressDefaults();
                setShippingAddressRequired(true);
            }  
        });
        
        if($('input[name=different]:checked').val()==0){   
            setShippingAddressRequired(false);
            clearShippingAddressCountry();
        }
               
    }

    if($('.checkout-delivery').length){
        checkRadio();
        $('body').on('click', '.shipping-options-method label', function (e) {
            if ($(e.target).closest('.shipping-option-tips, button, input, select, textarea, a').length) {
                return;
            }
            $('.shipping-options-method').removeClass('active');
            $(this).closest('.shipping-options-method').addClass('active');
            $(this).closest('.shipping-options-method').find('input:radio').prop('checked', true).attr('checked', true).change();
        });
        $('body').on('change', '#shipping-options .radio input', function () {
            checkRadio();
        });
        $(window).on('resize', resizeParcelShopSpsWidget);
        checkPaymentRadio();
        $('body').on('click', '.payment-options-method', function () {
            $('.payment-options-method').removeClass('active');
            $(this).closest('.payment-options-method').addClass('active');
            $(this).closest('.payment-options-method').find('input:radio').prop('checked', true).attr('checked', true).change();
        });
        $('body').on('change', '#payments-rates-list .radio input:radio', function () {
            checkPaymentRadio();
        });
    }
    
	$("body").on("click", ".add-wishlist", function(e) {
		e.preventDefault();
		var $this = $(this);
		var productId = $this.attr('data-id');
		if (!productId) {
			return;
		}
		$.post(shopurl + "api/addToWishlist/" + productId, { ajax: '1' }, function(data) {
			var json = JSON.parse(JSON.stringify(data));
            var wishlistCount = Number(json.count) || 0;
            $('.wishlist-header .pro-count, .wishlist-count').html(wishlistCount > 9 ? '9+' : wishlistCount);
            hmShowAlert({
                title: "",
                text: json.msg,
                icon: 'success',
                buttons:  
                {
                    confirm: {
                        text: lang.close,
                        value: true,
                        visible: true,
                        className: "",
                        closeModal: true
                    }, 
                }, 
                timer: 4000
            });  
            $('.add-wishlist[data-id="' + productId + '"]').each(function() {
                var $link = $(this);
                var label = json.status == true
                    ? $link.attr('data-remove-label')
                    : $link.attr('data-add-label');
                $link.toggleClass('active', json.status == true);
                $link.attr('aria-label', label).attr('title', label).attr('data-bs-original-title', label);
                $link.find('.wishlist-label').text(label);
            });
		});
	});
 
    if($('.variations').length){
            
        
        const $cartButton = $('.product-form-cart-submit.add-cart');
        const $soldOut = $('.product-form-sold-out');
        const $selectionPrompt = $('.product-form-select-options');

        function updatePackageButtonState() {
            let allSelected = true;
            $('.product-packages .variants-select').each(function () {
                const $select = $(this).find('select');
                if ($select.length) {
                    if (!$select.val()) {
                        allSelected = false;
                        return false;
                    }
                } else if ($(this).find('input[type=checkbox]:checked').length === 0) {
                    allSelected = false;
                    return false;
                }
            });

            if (allSelected) {
                $cartButton.show();
                $soldOut.addClass('d-none');
            } else {
                $cartButton.hide();
                $soldOut.removeClass('d-none');
            }
        }
        
        var variants = JSON.parse(base64ToUtf8(document.getElementById('js-variants').textContent.trim()));
        var optionLabels = JSON.parse(base64ToUtf8(document.getElementById('js-option-labels').textContent.trim()));
        var $variationsResetLink = $('.reset-product-options[data-reset-context="variations"]');
        var $variantStock = $('.product-single .product-stock');
        var $variantDelivery = $('.product-single .shippingMsg');
        var variantRequest = null;
        var variantRequestId = 0;

        function setVariantButtonState(state) {
            $cartButton.prop('disabled', state !== 'ready').toggle(state === 'ready');
            $soldOut.toggleClass('d-none', state !== 'unavailable');
            $selectionPrompt.toggleClass('d-none', state === 'ready' || state === 'unavailable');
            $selectionPrompt.attr('aria-busy', state === 'checking' ? 'true' : 'false');
            if (state === 'choose') {
                var selections = getSelections();
                var color = false;
                var size = false;
                var other = false;
                $('.variations .variants-select').each(function () {
                    if (selections[$(this).data('id')]) {
                        return;
                    }
                    if ($(this).find('.variants-clr').length) {
                        color = true;
                    } else if ($(this).find('.variants-size').length) {
                        size = true;
                    } else {
                        other = true;
                    }
                });
                var label = other ? 'variant' : (color && size ? 'color-size' : (color ? 'color' : (size ? 'size' : 'variant')));
                $selectionPrompt.find('span').text($selectionPrompt.attr('data-select-' + label));
            } else if (state === 'checking' || state === 'error') {
                $selectionPrompt.find('span').text($selectionPrompt.attr('data-' + state));
            }
        }

        function get_variants(){
            var requestId = ++variantRequestId;
            if (variantRequest) variantRequest.abort();
            $variantStock.addClass('d-none').removeClass('d-flex').find('.product-status').empty();
            $variantDelivery.addClass('d-none');
            $('.product-single input[name=product_variant]').val('');
            if (!allVariationOptionsSelected()) {
                var hasPurchasableVariant = variants.some(function (variant) { return variant.can_buy; });
                setVariantButtonState(hasPurchasableVariant ? 'choose' : 'unavailable');
                return;
            }

            var selections = getSelections();
            var selectedVariant = variants.find(function (variant) {
                return variant.can_buy && compatible(variant, selections);
            });
            if (!selectedVariant) {
                setVariantButtonState('unavailable');
                return;
            }

            setVariantButtonState('checking');
            var params = {
                variants: Object.values(selections),
                product_id: $('.product-single').find('input[name=product_id]').val(),
                ajax: '1',
            };
            variantRequest = $.post(shopurl + "product/get_variant_data", params, function(json) {
                if (requestId !== variantRequestId) {
                    return;
                }
                if (!json || typeof json.can_buy !== 'boolean' || String(json.variant_id) !== String(selectedVariant.combination_id)) {
                    setVariantButtonState('error');
                    return;
                }

                $variantStock.find('.product-status').html(json.status_html);
                $variantStock.toggleClass('d-none', !json.status_html).toggleClass('d-flex', !!json.status_html);
                $variantDelivery.toggleClass('d-none', !json.can_show_delivery);
                $('.product-single .product-price').html(json.price_html);
                updateQuatroCalculatorButton();
                $('.product-sku .text').html(json.code);
                $('.product-single input[name=product_variant]').val(json.variant_id);
                hmSetProductQuantityLimit(json.max_quantity);
                setVariantButtonState(json.can_buy ? 'ready' : 'unavailable');
            }, 'json').fail(function (xhr, status) {
                if (requestId === variantRequestId && status !== 'abort') {
                    setVariantButtonState('error');
                }
            });
        }

        function allowedOptionsFor(attrId, selections) {
            var set = new Set();
            for (var i=0;i<variants.length;i++){
                var v = variants[i];
                if (v.can_buy && compatible(v, selections, attrId)) {
                    if (v.options && v.options.hasOwnProperty(attrId)) {
                        set.add(String(v.options[attrId]));
                    }
                }
            }
            return set;
        }
 
        function getSelections() {
            var sel = {};
            $('.variations .variants-select').each(function(){
                var attrId = $(this).data('id');
                var v = $(this).find('select').val();
                if (v === undefined) v = $(this).find('input[type=radio]:checked').val();
                sel[attrId] = v || '';
            });
            return sel;
        }

        function selectSingleColorOptions() {
            var selected = false;
            $('.variations .variants-clr').each(function () {
                var $options = $(this).find('input[type=radio]:not(:disabled)');
                if ($options.length !== 1) {
                    return;
                }

                $options
                    .prop('checked', true)
                    .attr('data-default-selected', '1')
                    .closest('.swatch')
                    .addClass('active');
                selected = true;
            });

            return selected;
        }

        function allVariationOptionsSelected() {
            var selections = getSelections();
            var hasOptions = false;
            for (var attrId in selections) {
                if (!selections.hasOwnProperty(attrId)) {
                    continue;
                }
                hasOptions = true;
                if (!selections[attrId]) {
                    return false;
                }
            }

            return hasOptions;
        }

        function updateSelectedTitles() {
            var selections = getSelections();
            for (var attrId in selections) {
                if (!selections.hasOwnProperty(attrId)) continue;
                var val = selections[attrId];
                if (!val) {
                    $('.variations label[for="variant-' + attrId + '"] span').text('');
                    continue;
                }
                var labelText = '';
                if (optionLabels.hasOwnProperty(attrId)) {
                    var opts = optionLabels[attrId];
                    if (opts.hasOwnProperty(val)) {
                        labelText = opts[val].name || '';
                    }
                } 
                var label = $('.variations label[for="variant-' + attrId + '"] span');
                label.text(labelText);
            }
        }

        function updateVariationsResetVisibility() {
            if (!$variationsResetLink.length) {
                return;
            }
            var visible = false;
            $('.variations .variants-select').each(function () {
                var $select = $(this).find('select');
                if ($select.length && $select.val()) {
                    visible = true;
                    return false;
                }
                var $checked = $(this).find('input[type=radio]:checked:not([data-default-selected="1"]), input[type=checkbox]:checked');
                if ($checked.length) {
                    visible = true;
                    return false;
                }
            });
            if (visible) {
                $variationsResetLink.removeClass('d-none');
            } else {
                $variationsResetLink.addClass('d-none');
            }
        }

        function applyAvailability() {
            var selections = getSelections();
            $('.variations .variants-select').each(function(){
                var attrId = String($(this).data('id')); 
                var allowed = allowedOptionsFor(attrId, selections);
                var isSelect = $(this).find('select').length > 0;
                if (isSelect) {
                    var $select = $(this).find('select');
                    var cur = $select.val() || '';
                    $select.find('option').each(function(){
                        var val = $(this).attr('value') || '';
                        if (val === '') return;
                        var ok = allowed.has(String(val));
                        setVariantOptionAvailability($(this), ok);
                        if (!ok && String(cur) === String(val)) cur = '';
                    });
                    if (cur === '') $select.val('');
                } else {
                    $(this).find('input[type=radio]').each(function(){
                        var $radio = $(this);
                        var val = $(this).val();
                        var ok = allowed.has(String(val));
                        setVariantOptionAvailability($radio, ok);
                    });
                }
            });
        }

        function changedIndex($container){
            var idx = $('.variations .variants-select').index($container);
            return idx >= 0 ? idx : 0;
        }

        function triggerAjax($container){
            var idx = changedIndex($container);
            if (typeof get_variants === 'function') get_variants(idx);
        }
 
        $(document).on('click', '.product-item.swatches-image .swatch label', function(){ 
            if ($(this).find('input:disabled').length) return;
            var variant_id = $(this).data('variant-id');
            if(variant_id){ 
                $('.product-details-img .product-thumb-horizontal div.slick-slide').removeClass('active');
                $('.product-details-img .product-thumb a[data-variant-id="' + variant_id + '"]').trigger('click');
                $('.product-details-img .product-thumb a[data-variant-id="' + variant_id + '"]').closest('.slick-slide').addClass('active'); 
            }
        });

        $(document).on('change', '.variations .variants-select select, .variations .variants-select input[type=radio]', function(){
            var $wrap = $(this).closest('.variants-select');
            applyAvailability();
            triggerAjax($wrap);
            updateSelectedTitles();  
            updateVariationsResetVisibility();
        });

        selectSingleColorOptions();
        applyAvailability();
        updateSelectedTitles();
        updateVariationsResetVisibility();
        get_variants();
        
    }
   
    if($('.packages').length){
            
        jQuery('.product-form-cart-submit.add-cart').hide();
        jQuery('.product-form-sold-out').removeClass('d-none');
        
        const $cartButton = $('.product-form-cart-submit.add-cart');
        const $soldOut = $('.product-form-sold-out');
        const $packagesResetLink = $('.reset-product-options[data-reset-context="packages"]');

        function updatePackageButtonState() {
            let allSelected = true;
            let anySelected = false;
            $('.product-packages .variants-select').each(function () {
                const $select = $(this).find('select');
                if ($select.length) {
                    const val = $select.val();
                    if (val) {
                        anySelected = true;
                    } else {
                        allSelected = false;
                        return false;
                    }
                    return;
                }

                const $radios = $(this).find('input[type=radio]');
                if ($radios.length) {
                    const checkedCount = $radios.filter(':checked').length;
                    if (checkedCount) {
                        anySelected = true;
                    } else {
                        allSelected = false;
                        return false;
                    }
                    return;
                }

                const $checkboxes = $(this).find('input[type=checkbox]');
                if ($checkboxes.length) {
                    const checkedBoxes = $checkboxes.filter(':checked').length;
                    if (checkedBoxes) {
                        anySelected = true;
                    } else {
                        allSelected = false;
                        return false;
                    }
                }
            });

            $('.product-packages .product-swatches-option').each(function () {
                if ($(this).find('.variants-select').length && !$('#package-' + $(this).data('id')).val()) {
                    allSelected = false;
                }
            });

            if (allSelected) {
                $cartButton.show();
                $soldOut.addClass('d-none');
            } else {
                $cartButton.hide();
                $soldOut.removeClass('d-none');
            }

            if ($packagesResetLink.length) {
                if (anySelected) {
                    $packagesResetLink.removeClass('d-none');
                } else {
                    $packagesResetLink.addClass('d-none');
                }
            }

            updateProductVariantsField();
        }
        
        $('.product-swatches-option').each(function () {
            const $container = $(this);
            const productId = $container.data('id');
            const $dataNode = $container.find('.package-variants-data');

            let variantRequest = null;
            let variants = [];
            let optionLabels = {};

            if ($dataNode.length) {
                const variantsB64 = $dataNode.data('variants') || '';
                const optionLabelsB64 = $dataNode.data('option-labels') || '';
                if (variantsB64) {
                    try {
                        variants = JSON.parse(base64ToUtf8(String(variantsB64)));
                    } catch (err) {
                        console.error('Failed to parse package variants data', err);
                        variants = [];
                    }
                }
                if (optionLabelsB64) {
                    try {
                        optionLabels = JSON.parse(base64ToUtf8(String(optionLabelsB64)));
                    } catch (err) {
                        console.error('Failed to parse package option labels', err);
                        optionLabels = {};
                    }
                }
            }
        
            function getSelections() {
                const sel = {};
                $container.find('.variants-select').each(function () {
                    const attrKey = String($(this).data('id'));
                    const $select = $(this).find('select');
                    let value = '';
                    if ($select.length) {
                        value = $select.val() || '';
                    } else {
                        const $radio = $(this).find('input[type=radio]:checked').first();
                        value = $radio.length ? $radio.val() : '';
                    }
                    sel[attrKey] = value;
                });
                return sel;
            }

            function allowedOptionsFor(attrId, selections) {
                if (!variants.length) {
                    return new Set();
                }
                const set = new Set();
                for (let i = 0; i < variants.length; i++) {
                    const v = variants[i];
                    if (v.can_buy && compatible(v, selections, attrId)) {
                        if (v.options && Object.prototype.hasOwnProperty.call(v.options, attrId)) {
                            set.add(String(v.options[attrId]));
                        }
                    }
                }
                return set;
            }

            function updateSelectedTitles() {
                const selections = getSelections();
                for (const attrId in selections) {
                    if (!Object.prototype.hasOwnProperty.call(selections, attrId)) continue;
                    const val = selections[attrId];
                    const $label = $container.find('label[for="package-variant-' + productId + '-' + attrId + '"] span');
                    if (!val) {
                        $label.text('');
                        continue;
                    }
                    let labelText = '';
                    if (optionLabels.hasOwnProperty(attrId)) {
                        const opts = optionLabels[attrId];
                        if (opts && Object.prototype.hasOwnProperty.call(opts, val)) {
                            labelText = opts[val].name || '';
                        }
                    }
                    $label.text(labelText);
                }
            }

            function applyAvailability() {
                const selections = getSelections();
                $container.find('.variants-select').each(function () {
                    const attrId = String($(this).data('id'));
                    const allowed = allowedOptionsFor(attrId, selections);
                    const $radios = $(this).find('input[type=radio]');
                    if ($radios.length) {
                        $radios.each(function () {
                            const $radio = $(this);
                            const val = $radio.val();
                            const ok = allowed.has(String(val));
                            setVariantOptionAvailability($radio, ok);
                        });
                    }
                });
            }

        function triggerPackageAjax() {
            if (variantRequest) variantRequest.abort();
            $('#package-' + productId).val('');
            $container.find('input[name=product_variant]').val('');
            updateProductVariantsField();
            const selections = getSelections();
            const variantsArr = Object.values(selections);
            if (variantsArr.some(function (val) { return !val; })) {
                return;
            }
            const params = {
                variants: variantsArr,
                product_id: productId,
                    ajax: '1',
                };
                variantRequest = $.post(shopurl + "product/get_variant_data", params, function (data) {
                    let json;
                    try {
                        json = $.parseJSON(data);
                    } catch (err) {
                        console.error('Failed to parse package variant response', err, data);
                        return;
                    }
                    const variantId = json['can_buy'] ? json['variant_id'] : '';
                    $('#package-' + productId).val(variantId);
                    $container.find('input[name=product_variant]').val(variantId);
                    updatePackageButtonState();
                });
            }
    
            $container.on('change', '.variants-select select', function () {
                applyAvailability();
                triggerPackageAjax();
                updateSelectedTitles();
                updatePackageButtonState();
            });

            $container.on('change', '.variants-select input[type=radio]', function () {
                applyAvailability();
                triggerPackageAjax();
                updateSelectedTitles();
                updatePackageButtonState();
            });

            applyAvailability();
            updateSelectedTitles();
            updatePackageButtonState();
            const initialValues = Object.values(getSelections());
            const hasInitialSelection = initialValues.every(function (value) {
                return value !== '';
            });
            if (hasInitialSelection) {
                triggerPackageAjax();
            }
        });
        
        updateProductVariantsField();
    }
   
    });
})(jQuery);

(function ($) {
    function normalizeFilterText(value) {
        value = (value || '').toString().toLowerCase();
        if (typeof value.normalize === 'function') {
            value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
        return value;
    }

    $(document).on('input', '.js-attribute-filter-search', function () {
        var search = normalizeFilterText($(this).val());
        var $widget = $(this).closest('.filter-widget');

        $widget.find('[data-filter-name]').each(function () {
            var name = normalizeFilterText($(this).data('filter-name'));
            $(this).toggle(search === '' || name.indexOf(search) !== -1);
        });
    });
})(jQuery);
 
document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form[data-form-id]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
        if (!form.checkValidity()) {
            return;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'form_submit',
            form_id: form.getAttribute('data-form-id')
        });
    });
});


jQuery( document ).ready(function($) {
	function toggleCheckoutRegistrationPassword() {
		var enabled = $('input[name="register"]:checked').val() === '1';
		var $fields = $('.checkout-registration-password');
		$fields.toggleClass('d-none', !enabled);
		$fields.find('input').prop('disabled', !enabled).prop('required', enabled);
		if (!enabled) {
			$fields.find('input').val('');
		}
	}

	$(document).on('change', 'input[name="register"]', toggleCheckoutRegistrationPassword);
	toggleCheckoutRegistrationPassword();
	
	$('.checkout-delivery .radio input:radio').change(function () {
		$('.checkout-delivery .wrapper').hide();
		$('.checkout-delivery .wrapper input#packeta-name, .checkout-delivery .wrapper .parcel-shop-title').removeAttr('required');
		var showWrapper = $(this).data('custom');
		if(showWrapper == 'zasielkovna' || showWrapper == 'parcel_shop_sps' || showWrapper == 'parcel_shop_dpd'){
			var requiredSelector = (showWrapper == 'zasielkovna') ? 'input#packeta-name' : '.parcel-shop-title';
			$('.checkout-delivery .wrapper.wrapper-'+showWrapper+' '+requiredSelector).attr('required', 'required');
			$('.checkout-delivery .wrapper.wrapper-parcel_shop_sps .parcel-shop-service').val('sps');
			$('.checkout-delivery .wrapper.wrapper-'+showWrapper).fadeIn();
		}else{
			$('.checkout-delivery .wrapper input').not('.parcel-shop-service').val('');
		}
	});
	 
	var showWrapper = $(".checkout-delivery .radio input:radio:checked").data('custom');
	if(showWrapper){ 
		$('.checkout-delivery .wrapper.wrapper-'+showWrapper).fadeIn(); 
	}

    if($('.ig-preview-toggle').length){
        var toggles = document.querySelectorAll('.ig-preview-toggle');
        if (!toggles.length) return;

        toggles.forEach(function (toggle) {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                var wrapper = this.closest('.ig-card__preview');
                if (!wrapper) return;

                var expanded = wrapper.getAttribute('data-expanded') === '1';
                var shortText = wrapper.getAttribute('data-short') || '';
                var fullText = wrapper.getAttribute('data-full') || '';

                if (!expanded) {
                    wrapper.innerHTML = fullText.replace(/\n/g, '<br>');
                    wrapper.setAttribute('data-expanded', '1');
                    var back = document.createElement('a');
                    back.href = '#';
                    back.className = 'ig-preview-toggle';
                    back.textContent = 'Zobraziť menej';
                    wrapper.appendChild(document.createTextNode(' '));
                    wrapper.appendChild(back);
                    back.addEventListener('click', arguments.callee);
                } else {
                    wrapper.innerHTML = shortText.replace(/\n/g, '<br>');
                    wrapper.setAttribute('data-expanded', '0');
                    var more = document.createElement('a');
                    more.href = '#';
                    more.className = 'ig-preview-toggle';
                    more.textContent = 'Zobraziť viac';
                    wrapper.appendChild(document.createTextNode(' '));
                    wrapper.appendChild(more);
                    more.addEventListener('click', arguments.callee);
                }
            });
        }); 
    }

});
 
function showSelectedPickupPoint(point) { 
	
    this.innerText = (point ? point.name : "");
     
    document.getElementById('zasilkovna_name').value = (point ? point.name : ""); 
    document.getElementById('packeta-name').value = (point ? point.place+", "+point.name : "");
    sessionStorage.zasilkovnaPobockaName = (point ? point.name : "");

    document.getElementById('zasilkovna_id_zas').value = (point ? point.id : "");
    sessionStorage.zasilkovnaVybranaPobocka = (point ? point.id : "");
  
    document.getElementById('zasilkovna_street').value = (point ? point.street : "");
    sessionStorage.zasilkovnaVybranaPobockaStreet = (point ? point.street : "");

    document.getElementById('zasilkovna_city').value = (point ? point.city : "");
    sessionStorage.zasilkovnaVybranaPobockaCity = (point ? point.city : "");

    document.getElementById('zasilkovna_zip').value = (point ? point.zip : "");
    sessionStorage.zasilkovnaVybranaPobockaZip = (point ? point.zip : "");

    window.dispatchEvent(new CustomEvent("zasilkovnaPickupSelected", {detail: point}));

	$('.checkout-delivery .wrapper input').change(function () {  
		if($(this).val()){
			$('#button-shipping-method').removeClass('disabled');
		} 
	});
	
	if($('.checkout-delivery .wrapper input').val()){
		$('#button-shipping-method').removeClass('disabled');
	} 
	
}


// Instagram masonry + reflow on toggle
(function ($) {
    $(function() {
        var $grid = $('.instagram-feed-cards');
        if (!$grid.length || typeof Masonry === 'undefined') {
            return;
        }

        var msnry = new Masonry($grid[0], {
            itemSelector: '.ig-card-col',
            percentPosition: true,
            gutter: 15
        });

        if (typeof imagesLoaded !== 'undefined') {
            imagesLoaded($grid[0]).on('progress', function () {
                msnry.layout();
            });
        }

        $(document).on('click', '.ig-preview-toggle', function () {
            setTimeout(function () {
                msnry.layout();
            }, 120);
        });

        $(window).on('load', function () {
            msnry.layout();
        });
    });
})(jQuery);
